export const session = {
  title: "Inloggen",
  description: "Log in om je jurylijsten in te vullen.",
  fallback: "Lukt dat niet?",
  inloglink: {
    title: "Met een code per mail",
    what: "We mailen je een code van 6 cijfers waarmee je inlogt, zonder wachtwoord. De code werkt één keer en is 30 minuten geldig.",
    email: "E-mailadres",
    submit: "Stuur mij een inlogcode",
    invalidEmail: "Vul een geldig e-mailadres in.",
    sent: {
      title: "Kijk in je mailbox.",
      body: "Kennen we {{adres}}, dan ligt er binnen een paar minuten een inlogcode. Gebruik het adres dat in VBS staat.",
      resend: "Stuur de code nog eens",
    },
    code: {
      label: "Vul de code uit de mail in",
      fromBeheerder: "Kreeg je de code van je beheerder? Dan hoef je geen e-mailadres in te vullen.",
      submit: "Inloggen",
      invalid: "Deze code klopt niet of is verlopen. Na 5 foute pogingen werken de codes niet meer. Vraag dan een nieuwe mail aan of druk op de knop in de mail.",
    },
    tooOften: {
      title: "Je hebt te vaak een inlogcode aangevraagd.",
      body: "Probeer het over een kwartier opnieuw.",
    },
  },
  providers: {
    title: "Met je Microsoft-account",
    hint: "Gebruik het account met het e-mailadres dat in VBS staat. Een beheerder van alle banen logt altijd zo in.",
    google: "Inloggen met Google",
    microsoft: "Inloggen met Microsoft",
    failed: "De knoppen voor Google en Microsoft konden niet worden geladen. Ververs de pagina om het opnieuw te proberen.",
  },
  refused: {
    onbekend: {
      title: "Dit account kennen we niet",
      body: "In VBS staat geen waarnemer, rekenkamer of actief account met dit e-mailadres, of de provider heeft het adres niet bevestigd. Log in met het account waarvan het e-mailadres in VBS staat, of vraag een inloglink aan. Een beheerder van alle banen logt de eerste keer met Google in met een zakelijk Google-account van het eigen e-maildomein.",
    },
    mislukt: {
      title: "Inloggen is niet gelukt",
      body: "Het inloggen is onderweg afgebroken, bijvoorbeeld omdat het te lang duurde. Probeer het opnieuw.",
    },
  },
  landing: {
    busy: "Je wordt ingelogd…",
    invalidTitle: "Deze inloglink werkt niet",
    invalidBody: "De link is verlopen of al gebruikt. Vraag een nieuwe aan.",
    back: "Naar inloggen",
  },
  waiting_one: "Op dit apparaat staat nog 1 antwoord dat niet is verstuurd. Log in als de waarnemer die het gaf, dan wordt het verstuurd.",
  waiting_other:
    "Op dit apparaat staan nog {{count}} antwoorden die niet zijn verstuurd. Log in als de waarnemer die ze gaf, dan worden ze verstuurd.",
  failed: "Inloggen lukt nu niet. Controleer je verbinding en probeer het opnieuw.",
} as const;
